import { FC } from 'react';
import { BillingCountry } from './Components/BillingCountry';
import { ICountryDetail } from '../../../../../types/countries';
import { IBillingData, ISpecialBusinessNameTypes } from '../../../../../types/bussines';
import './BillingCountryTab.scss';

interface IBillingCountryTab {
  countriesList: ICountryDetail[];
  billingData?: IBillingData[];
  organizationName?: string;
  updateWithoutLoaders: (disabledLoader?: boolean) => void;
  specialBusinessTypes?: ISpecialBusinessNameTypes;
}

const BillingCountryTab: FC<IBillingCountryTab> = ({
  countriesList,
  billingData,
  organizationName,
  updateWithoutLoaders,
  specialBusinessTypes
}: IBillingCountryTab) => {
  return (
    <div id="billingCountryTab">
      {billingData && billingData.length > 0 ? (
        <div className="containerCountries">
          {billingData?.map(item => {
            return (
              <BillingCountry
                data={item}
                key={`billing-country-${item.id}`}
                countriesList={countriesList}
                organizationName={organizationName}
                updateWithoutLoaders={updateWithoutLoaders}
                specialBusinessTypes={specialBusinessTypes}
              />
            );
          })}
          <div className="marginAtBottom w-20 h-10" />
        </div>
      ) : (
        <div className="noData">Sin datos de facturación</div>
      )}
    </div>
  );
};

export default BillingCountryTab;
